import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroSlides } from '@/mocks/videoData';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const goTo = useCallback((index: number) => {
    setCurrent(index);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="首页轮播推荐">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.imageUrl}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full mb-4">
              {slide.category}
            </span>
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3 leading-tight">
              {slide.title}
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-heading mb-2">
              {slide.subtitle}
            </p>
            <p className="text-sm md:text-base text-white/70 mb-6 max-w-lg">
              {slide.description}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex items-center gap-1.5">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-sm" style={{ color: 'oklch(var(--accent-500))' }}></i>
                </span>
                <span className="text-white font-semibold text-lg">{slide.rating}</span>
              </div>
              <a
                href={`/article/${slide.slug}`}
                onClick={(e) => { e.preventDefault(); navigate(`/article/${slide.slug}`); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg cursor-pointer transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-fill text-lg"></i>
                </span>
                立即观看
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`rounded-full cursor-pointer transition-all duration-300 ${
              i === current
                ? 'bg-white w-8 h-2.5'
                : 'bg-white/40 hover:bg-white/70 w-2.5 h-2.5'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo((current - 1 + heroSlides.length) % heroSlides.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white cursor-pointer transition-colors"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={() => goTo((current + 1) % heroSlides.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white cursor-pointer transition-colors"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}